import { SESSION_EXPIRED, CLEAR_SESSION_EXPIRED } from '../actions/types';

const initialState = {
  postLoginRedirect: null,
};

const sessionRecoveryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_EXPIRED:
      return {
        postLoginRedirect: action.payload?.returnUrl ?? null,
      };
    case CLEAR_SESSION_EXPIRED:
      return { ...initialState };
    default:
      return state;
  }
};

export default sessionRecoveryReducer;
